<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    subTitle: {
      type: String,
      default: '',
    },
    showBorder: {
      type: Boolean,
      default: true,
    },
    note: {
      type: String,
      default: '',
    },
  },
};
</script>

<template>
  <div
    class="w-full"
    :class="{
      'border-b border-solid border-slate-50 dark:border-slate-700/30':
        showBorder,
    }"
  >
    <div class="w-full">
      <p
        v-if="title"
        class="text-base text-woot-500 dark:text-n-gray-1 mb-0 font-medium"
      >
        {{ title }}
      </p>
      <p
        class="text-base mb-1 text-slate-700 dark:text-n-gray-5 leading-5 tracking-normal mt-1"
      >
        <slot v-if="subTitle" name="subTitle">
          {{ subTitle }}
        </slot>
      </p>
      <p v-if="note">
        <span class="font-semibold">{{ $t('INBOX_MGMT.NOTE') }}</span>
        {{ note }}
      </p>
    </div>
    <div class="w-full" :class="{ 'mt-6': title }">      
      <slot />
    </div>
  </div>
</template>
